<template>
  <div class="root">
    <!-- <scaleplate></scaleplate> -->
    <div class="tools">
      <!-- <div class="btn"> -->
        <el-button size="mini" style="width: 50px;padding:5px;margin-left: 10px;" type="primary" @click="restoration">复位</el-button>
        <!-- <el-button size="mini" style="width: 50px;padding:5px;" type="primary" @click="clear">清空</el-button> -->
        <!-- <el-button size="mini" style="width: 50px;padding:5px;" type="primary" @click="save">保存</el-button> -->
        <!-- <el-button size="mini" style="width: 50px;padding:5px;margin-right: 10px;" @click="canRedo">撤销</el-button> -->
      <!-- </div> -->
      <!-- <div style="margin-bottom: 5px;color:#FF8C00;font-weight: bold;">温馨提示：先画区域才画设备 否则会出现无法预期的结果</div> -->
    </div>
    <div ref="stencils"></div>
    <div class="mainBlock">
      <div ref="main" style="width: 100px;"></div>
    </div>
    <!-- <drawer ref="drawer"></drawer> -->
    <mydrawer ref="drawer"></mydrawer>
  </div>
</template>

<script>
//  gmt：门磁类型 sdt：烟雾探测器 lgat：工业燃气报警器 gahft：燃气报警主机4G
// import {getSlideList} from './drawing_list'
import {register,getTeleport} from '@antv/x6-vue-shape'
import {Graph,Shape} from '@antv/x6'
import {Stencil} from '@antv/x6-plugin-stencil'
import {Snapline} from '@antv/x6-plugin-snapline'
import {Transform} from '@antv/x6-plugin-transform'
import {Clipboard} from '@antv/x6-plugin-clipboard'
import {Keyboard} from '@antv/x6-plugin-keyboard'
import {History} from '@antv/x6-plugin-history'
import {Selection} from '@antv/x6-plugin-selection'
import {Export} from '@antv/x6-plugin-export'

// import T from './title.vue'
// 直线
import Straightline from './tools/straightline.vue'
// 虚线
import Dottedline from './tools/dottedline.vue'
// 滚动
import ScrollDottedLine from './tools/scrollLine.vue'
// 横线
import Across from './tools/across.vue'
// 门
import Door from './tools/door.vue'

// 设置设备的节点
// 烟感
import Callthepolice from './device/callthepolice.vue'
// 消防
import Firecontrol from './device/firecontrol.vue'
// 门磁
import Getemagnetism from './device/gatemagnetism.vue'

// 通用设备图标
import General from './device/general.vue'

import drawer from './drawer.vue'
import mydrawer from './block-drawer.vue'

export default {
  components:{
    drawer,
    mydrawer,
  },
  data () {
    return {
      graph:{},
      groups:[],
      data:{},
      stenCil:{},
      dataObj:{
        arr:[],
        graphJson:{}
      },
      zIndex:'',
      deviceListCopy:[],     // 设备类型备份
      deviceList:[],         // 设备类型集合
      delList:[],            // 设备删除
      deviceNodeList:[],     // 设备图标数组
    }
  },
  mounted(){
    console.log("data",this.obj)
    // 温馨提示：先画区域才画设备 否则会出现无法预期的结果
    const h = this.$createElement;
    this.$notify({
      title: '温馨提示',
      dangerouslyUseHTMLString: true,
      // message: '<span>先画区域然后在区域内画设备，<b style="color:Orange"> 另外请拖动设备到指定区域后，在目标设备处停一下，等加载出来在移动鼠标，否则会出现无法预期的结果</b></span>',
      message: '<span style="color:Orange"> 先画区域然后在区域内放设备 否则设备在进行保存时将无法添加</span>',
      type:'warning'
    });
    this.init();
  },
  methods:{
    // 初始化
    init(){
      this.getGraph();
      new Promise(resolve=>{
        this.getData(resolve);
        }).then(res=>{
          this.getStenCil();
        })
      // this.getSnaplice();
      // this.getTransform();
      // 复制粘贴
      // this.getKeyboard();
    
      // this.getHistory();
      this.bindingEvent();
      // 注册节点事件
      // this.nodeEvent();
    },
    // 更改颜色
    setColor(){

    },
    // 获取画板
    getGraph() {
      this.graph = new Graph({
        container:this.$refs.main,
        autoResize:true,
        backgroundColor: {
          color:'#ffffff'
        },
        grid:{
          visible:true,
          type:'doubleMesh',
          args: [
            {
              color: '#eee', // 主网格线颜色
              thickness: 1, // 主网格线宽度
            },
            {
              color: '#ddd', // 次网格线颜色
              thickness: 1, // 次网格线宽度
              factor: 4, // 主次网格线间隔
            },
          ],
        },
        panning:true,
        mousewheel:{
          enabled: true,
          modifiers:'Ctrl'
        },
        embedding:{
          enabled: true
        }
      });

      this.graph.use(new Export())
    },
    // 获取数据
    async getData(resolve){
    
      import('./drawing_list.js').then(res=>{
        this.deviceNodeList = res.data;
        this.createNode();
        resolve();
      })
    },
    // 创建节点
    createNode(){
      this.graph.fromJSON({});
      this.graph.centerContent();
    },
    getSnaplice(){
      this.graph.use(
        new Snapline({
          enabled: true,
          sharp:true
        })
      )
    },
    getTransform(){
      this.graph.use(
        new Transform({
          resizing:{
            enabled: true,
            autoScroll:true
          },
          rotating:{
            enabled: true,
            autoScroll:true
          }
        })
      )
    },
    bindingEvent(){
        this.graph.bindKey('ctrl+c', () => {
          const cells = this.graph.getSelectedCells()
          if (cells.length) {
            this.graph.copy(cells)
          }
          return false
        })

        this.graph.bindKey('ctrl+v', () => {
          if (!this.graph.isClipboardEmpty()) {
            const cells = this.graph.paste({ offset: 32 })
            this.graph.cleanSelection()
            this.graph.select(cells)
          }
          return false
        })
    },
    nodeEvent(){
      this.graph.on('node:contextmenu',({cell})=>{
        console.log("鼠标右击",cell);

        if(!!!cell.store.data.type){
          this.$confirm('是否删除设备?', '删除', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            // console.log('删除总数')
            let index = -1;
            for(let i = 0;i<this.deviceListCopy.length;i++){
              if(this.deviceListCopy[i].nodeId == cell.id){
                index = i;
                break;
              }
            }
            
            console.log('index',index)
            if(index == -1){

              this.graph.removeNode(cell)
              this.deviceList = this.deviceList.filter(item=>item.nodeId != cell.id);
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              // this.save(null,false,true)
              return;
            }

            if(this.deviceListCopy[index].deviceId){
              this.$message.warning('设备已安装无法删除')
              return;
            }
            
            this.delList.push(this.deviceListCopy[index].id);
            console.log('删除的数组-----------------',this.delList,this.deviceListCopy[index].id)
            this.graph.removeNode(cell);
            this.del(false,()=>{
              // this.graph.removeNode(cell);
              this.delList = [];
              this.deviceListCopy.splice(index,1);
              this.deviceListCopy = [...this.deviceListCopy,...this.deviceList]
            })
          })
        }else{
          this.$refs.drawer.setDrawer(true,cell,this.graph);
          this.zIndex = cell.store.data.zIndex;
        }
      })
      // 节点离开事件node:mouseleave
      this.graph.on('node:embedded',({cell})=>{
        if(!!!cell.store.data.type){
          let nodeId = cell.id;

          for(let i = 0;i<this.deviceList.length;i++){
            if(this.deviceList[i].nodeId == nodeId){
              return;
            }
          }

          for(let i = 0;i<this.deviceListCopy.length;i++){
            if(this.deviceListCopy[i].nodeId == nodeId){
              return;
            }
          }

          console.log('设备',cell.getData(),cell.id);
          let {svgData:{devType}} = cell.getData()
          // if(this.deviceIconList.includes())
          this.deviceList.push({
            deviceTypeCode:devType,
            nodeId:nodeId,
            nodeDetails:''
          })
        }
      })
    },
    getStenCil(){
      let groups = [];

      groups.push(
        {
          name:'group0',
          title:'工具栏'
        },
        {
          name:'group1',
          title:'设备'
        }
      )

      this.stenCil = new Stencil({
          target:this.graph,
          groups: groups,
          collapse:true,
          stencilGraphWidth: 100,
          stencilGraphHeight: 0,
          stencilGraphPadding:10,
          center:false,
          layoutOptions:{
            columns:3,
            rowHeight:'auto',
            resizeToFit:true
          },
        })
        // 创建侧边栏
        // this.$refs.stencils.appendChild(this.stenCil.container);
       this.setTools();
    },
    setTools(){
      // 注册节点
      this.registerVueNode();
      this.registerDevice();
      // 放入侧边栏的工具栏数据
      let arr = [];
      let devArr = [];
      // 设置侧边栏数据
      this.setToolsData(arr);
      this.setDevice(devArr);
      // 放入侧边栏分组 
      this.stenCil.load(arr,'group0')
      this.stenCil.load(devArr,'group1')
    },
    // 注册vueNode
    registerVueNode(){
      register({
        shape:'custom-vue-straightline',
        width: 200,
        height: 200,
        component:Straightline
      })

      register({
        shape:'custom-vue-dottedline',
        width: 200,
        height: 200,
        component:Dottedline
      })

      register({
        shape:'custom-vue-scoll',
        width: 200,
        height: 200,
        component:ScrollDottedLine
      })

      register({
        shape:'custom-vue-across',
        width: 200,
        height: 200,
        component:Across
      })

      register({
        shape:'custom-vue-door',
        width: 200,
        height: 200,
        component:Door
      })
    },
    setToolsData(arr){
      let side = this.graph.createNode({
        shape: 'rect',
        x: 40,
        y: 40,
        width: 20,
        height:20,
        type:'picture',
        attrs: {
            body: {
              fill: "rgba(0,0,0,0.0001)",
              refPoints: '0,145,120,145,63,0,0,145',
              stroke: "rgb(151, 151, 151)",
            },
          },
      })

      let circle = this.graph.createNode({
        shape: 'circle',
        x: 40,
        y: 40,
        type:'picture',
        width: 20,
        height:20,
        attrs: {
            body: {
              fill: "rgba(0,0,0,0.0001)",
              refPoints: '0,145,120,145,63,0,0,145',
              stroke: "rgb(151, 151, 151)",
            },
          },
      })

      let across = this.graph.createNode({
        shape:'custom-vue-across',
        x: 200,
        y: 150,
        type:'line',
        width: 20,
        height:20,
        data:{
          borderColor:''
        }
      })

      let straightline = this.graph.createNode({
        shape:'custom-vue-straightline',
        x: 200,
        y: 150,
        type:'line',
        width: 20,
        height:20,
        data:{
          borderColor:''
        }
      })

      let dottedline = this.graph.createNode({
        shape:'custom-vue-dottedline',
        x: 200,
        y: 150,
        type:'line',
        width: 20,
        height:20,
        data:{
          borderColor:''
        }
      })


      let scrollDottedline = this.graph.createNode({
        shape:'custom-vue-scoll',
        x: 200,
        y: 150,
        type:'line',
        width: 20,
        height:20,
      })

      let triang =this.graph.addNode({
          shape: 'polyline',
          x: 180,
          y: 150,
          type:'picture',
          width: 20,
          height:20,
          attrs: {
            body: {
              fill: "rgba(0,0,0,0.0001)",
              refPoints: '0,145,120,145,63,0,-0.2,145.3',
              stroke: "rgb(151, 151, 151)",
            },
          },
        })

      
        let door = this.graph.createNode({
          shape:'custom-vue-door',
          x: 200,
          y: 150,
          type:'line',
          width: 20,
          height:20,
          data:{
            borderColor:''
          }
        })


      arr.push(side);
      arr.push(circle);
      arr.push(triang);
      arr.push(door)
      arr.push(across);
      arr.push(straightline);
      arr.push(dottedline);
      arr.push(scrollDottedline);
    },
    // 注册设备节点
    registerDevice(){
      register({
        shape:'custom-vue-callthepolice',
        width: 200,
        height: 200,
        component:Callthepolice
      })

      register({
        shape:'custom-vue-firecontrol',
        width: 200,
        height: 200,
        component:Firecontrol
      })

      register({
        shape:'custom-vue-getemagnetism',
        width: 200,
        height: 200,
        component:Getemagnetism
      })

      this.deviceNodeList.forEach(item=>{
        // console.log('itemDeviceNdoeList',this.deviceList)
        register({
          shape:'custom-vue-'+item.name,
          width:200,
          height:200,
          component:General
        })
      })
    },
    // 创建设备节点
    setDevice(arr){
      let callthepolice = this.graph.createNode({
        shape:'custom-vue-callthepolice',
        x: 200,
        y: 150,
        width: 20,
        height:20,
        data:{
          svgData:{
            borderColor:'',
            backColor:'',
            devName:'烟感',                   // 设备名字
            openPolice: false,               // 开启报警
            openOnLine: false,               // 是否在线
            openOffLine:false,               // 是否离线
            polineColor: 'red',              // 报警颜色
            onLineColor: 'green',            // 在线颜色
            offLineColor: '#979797',         // 离线颜色
            devType:'sdt'
          }
        }
      })
      
      let firecontrol = this.graph.createNode({
        shape:'custom-vue-firecontrol',
        x: 200,
        y: 150,
        width: 20,
        height:20,
        data:{
          svgData:{
            devName:'工业燃气报警',
            borderColor:'',
            backColor:'',
            openPolice: false,               // 开启报警
            openOnLine: false,               // 是否在线
            openOffLine:false,               // 是否离线
            polineColor: 'red',              // 报警颜色
            onLineColor: 'green',            // 在线颜色
            offLineColor: '#979797',         // 离线颜色
            devType:'lgat'
          }
        }
      })

      let getemagnetism = this.graph.createNode({
        shape:'custom-vue-getemagnetism',
        x: 200,
        y: 150,
        width: 20,
        height:20,
        data:{
          svgData:{
            devName:'门磁',
            borderColor:'',
            backColor:'',
            openPolice: false,               // 开启报警
            openOnLine: false,               // 是否在线
            openOffLine:false,               // 是否离线
            polineColor: 'red',              // 报警颜色
            onLineColor: 'green',            // 在线颜色
            offLineColor: '#979797',         // 离线颜色
            devType:'gmt'
          }
        }
      })

      arr.push(callthepolice);
      arr.push(firecontrol);
      arr.push(getemagnetism);

      this.deviceNodeList.forEach(item=>{
          let device = this.graph.createNode({
            shape:'custom-vue-'+item.name,
            x: 200,
            y: 150,
            width: 20,
            height:20,
            data:{
              svgData:{
                devName:item.devName,
                domId:'custom-vue-'+item.name,
                icon:item.icon,
                borderColor:'',
                backColor:'',
                openPolice: false,               // 开启报警
                openOnLine: false,               // 是否在线
                openOffLine:false,               // 是否离线
                polineColor: 'red',              // 报警颜色
                onLineColor: 'green',            // 在线颜色
                offLineColor: '#979797',         // 离线颜色
                devType:item.devType,
              }
            }
          })

          arr.push(device)
        })
    },
    getBase64(img){
        
    },
    // 复制粘贴
    getKeyboard(){
      this.graph.use(
        new Clipboard({
          enabled:true
        })
      )

      this.graph.use(
        new Keyboard({
          enabled:true,
          global: true,
        })
      )

      // this.getSelection();
    },
    getHistory(){
      this.graph.use(
        new History({
          enabled:true
        })
      )
    },
    // 框选
    getSelection(){
      this.graph.use(
        new Selection({
          enabled: true,
          showNodeSelectionBox: true,
          // multiple:true,
          // multipleSelectionModifiers:['shift'],
          // rubberband:true,
        })
      )
    },
    canRedo(){
      this.graph.undo()
    },
    clear(){
      this.$confirm('是否清空?, 是否继续?', '清空', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
        }).then(() => {
                this.$message({
                  type: 'success',
                  message: '清空成功!'
                });
              this.graph.fromJSON({})
              this.save('',true)
          })
      
    },
    setCanvas(data,dataObj){
      console.log("设置json",data,dataObj)
      this.deviceList = [];
      this.deviceListCopy = dataObj.deviceLayouts;
      this.delList = [];

      setTimeout(()=>{
        this.graph.fromJSON(data == null || data == undefined?{}:data);

        if( JSON.stringify(data) == '{}' ){
          console.log('cetrue')
          this.graph.fromJSON({})
          return
        };
      if(data != null || data != undefined){
        setTimeout(()=>{
          let nodeList = this.graph.getRootNodes();
          // 节点判断
          data.cells.forEach((item,index)=>{
            let data = item.data;
            let node = nodeList[index];
            if(item.type == "line" && item.type == node.store.data.type){
              node.store.data.data.borderColor = ''
              this.$nextTick(()=>{
                node.setData({
                  borderColor:data.borderColor
                })
              })
            }else{
                this.deviceListCopy.forEach((devItem,index)=>{
                if(item.id == devItem.nodeId){
                  console.log('设备',devItem.warnStatus,devItem.status);

                  let param = {
                    openPolice:false,
                    openOffLine:false,
                    openOnLine:false,
                    devId:devItem.deviceId
                  };

                  if(devItem.warnStatus == 0)param.openPolice = true;
                  else if(devItem.status == 0)param.openOffLine = true;
                  else param.openOnLine = true;
                
                  console.log('param',param,node)
                  
                  node.setData({ 
                      svgData:{
                        openPolice:false,
                        openOffLine:false,
                        openOnLine:false,
                        devId:null
                      }
                  })

                  this.$nextTick(()=>{
                    console.log('测试+++++++++',param)
                    setTimeout(()=>{
                      node.setData({ 
                        svgData:{...param}
                      })
                    },100)
                  })
                }else{
                  
                  let data = node.getData();
                  if(data){
                    console.log('测试节点',node.getData(),node)
                    let isDev = false;
                    for(let i = 0;i<this.deviceListCopy.length;i++){
                      let nodeItem = this.deviceListCopy[i];
                      if(nodeItem.nodeId == node.id){
                        isDev = true;
                        break;
                      }
                    }
                    if(!isDev){
                      console.log('设备未找到',isDev)
                      this.graph.removeNode(node)
                    }
                  }
                }
              })
            }
          })
        },15)
      }
        this.restoration()
      },500)
     
      
     
    },
    image(imgurl,resolve) {   //imgurl   本地图片路径  
      var img = imgurl ;
      function getBase64Image(img) {
        var canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        var ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, img.width, img.height);
        var ext = img.src.substring(img.src.lastIndexOf(".") + 1).toLowerCase();
        var dataURL = canvas.toDataURL("image/" + ext);
        return dataURL;
      }

      var image = new Image();
      image.src = img;
      let base64 = ''
      image.onload = function() {
        base64 = getBase64Image(image);    //转换之后的图片路径'
        console.log('base648--------')
      }
    },
    // 删除
    del(isClear = false,callback){
       
      let data = this.graph.toJSON();
      data = data.cells.length == 0?null:data;
      if(data == null && !isClear){
        this.$message.warning('请添加施工图数据')
        return;
      }
      data = JSON.stringify(data);
      let img = ''
      this.graph.toPNG(res=>{
        img = res;
        this.$parent.del(data,img,this.delList,callback);
      })
    },
    //保存
    save(event,isClear = false,del = false,callback){
      
      let data = this.graph.toJSON();
      data = data.cells.length == 0?null:data;
      if(data == null && !isClear){
        this.$message.warning('请添加施工图数据')
        return;
      }
      data = JSON.stringify(data);
      let img = ''
      this.graph.toPNG(res=>{
        img = res;
        if(del){
          this.$parent.save(data,img,this.delList,callback)
          return;
        }

        

        this.$parent.save(data,img,this.deviceList,()=>{
          // this.deviceListCopy = [...this.deviceListCopy,...this.deviceList]
          console.log('保存',this.deviceListCopy)
        });
      })
      
      // alert(data)
      
    },
    // 复位
    restoration(){
      this.graph.centerContent()
    }
  }
}
</script>

<style lang="scss" scoped>
// ::v-deep .x6-widget-stencil-content{
//   // background-image: linear-gradient(300deg, #4AA7FF 90%, #246EFF 100%);
// }
// ::v-deep .x6-widget-stencil-group-title{
//   // background-color: red;
// }

// ::v-deep .x6-graph.x6-graph-pannable{
//   width: 100% !important;

//     // margin-left: 150px;
// }

// ::v-deep .x6-widget-stencil {
//   z-index: 99;
//     width: 150px;
// }

// ::v-deep .x6-widget-stencil-group .x6-graph{
//   width: 100% !important;
//   min-height: 101px !important;
//   overflow: auto !important;
// }

.mainBlock{
  width: 100%;
  height: 100%;
  // margin-left: 150px;
}
.root{
  width: 100%;
  height: 100%;
  display: flex;
  position: relative;
  // background-color: rgb(36, 136, 164);
}
.stencil{
  width: 150px;
}
.tools{
  position: absolute;
  z-index: 99;
  right: 0;
  background-color: rgba(249, 249, 249, 0.876);
  box-shadow: 0px 6px 5px rgba(0,0,0,0.5);
  min-width: 100px;
  // min-width: 200px;
  height: 50px;
  border-radius: 10px 0 0 10px;
  padding-right: 5px;
  display: flex;
  // flex-direction: column;
  justify-content: center;
  align-items: center;
  // button{
  //   margin-top: 16px;
  // }
}


.custom-side{
  height: 100%;
    width: 100%;
    border: 2px solid rgb(151, 151, 151);
}
</style>